export const iconFontAwesomeMoneyBitcoinSign = (
	<i className="fa-solid fa-bitcoin-sign"></i>
);
